import { Helmet } from 'react-helmet'

import { LegalSideNav } from './components/LegalSideNav'
import { TERMS_SECTIONS } from './content/termsSections'

export function Terms() {
  return (
    <section className="mx-auto max-w-(--maxw) px-5.5 pt-24 pb-16 max-md:pt-16 max-md:pb-12">
      <Helmet>
        <title>Terms &amp; Conditions</title>
      </Helmet>
      <meta
        name="description"
        content="The Customer Terms of Service between you and Cai Labs, Inc. governing use of the FuelApp Platform and related services."
      />
      <div className="grid grid-cols-[200px_minmax(0,760px)] items-start justify-center gap-16 max-[900px]:grid-cols-[minmax(0,760px)]">
        <LegalSideNav sections={TERMS_SECTIONS} />

        <div className="min-w-0">
          <div className="mb-12 flex flex-col gap-4">
            <span className="eyebrow self-start">Legal</span>
            <h1 className="h2 mt-2">Terms &amp; Conditions</h1>
            <p className="text-ink-400 m-0 font-mono text-xs leading-normal">
              Last Modified: August 26, 2026
            </p>
            <p className="text-md text-ink-700 leading-[1.6]">
              These Customer Terms of Service (these &ldquo;Customer Terms&rdquo;) are between you
              (&ldquo;you&rdquo;, &ldquo;Customer&rdquo; (with respect to a business, organization or other
              legal entity), or &ldquo;Authorized User&rdquo;) and Cai Labs, Inc. (or its successors or
              assigns) (&ldquo;Cai Labs&rdquo;, &ldquo;we&rdquo;, &ldquo;our&rdquo;, or &ldquo;us&rdquo;) and
              describe your rights and responsibilities when using the mobile and/or web-based software
              platform and related technology services (the &ldquo;Services&rdquo;) offered by us. These
              Customer Terms and any Order Form(s) form the &ldquo;Agreement&rdquo; between you and us with
              respect to the Services.
            </p>
            <p className="text-md text-ink-700 leading-[1.6]">
              Please read these terms carefully to ensure you understand each provision. These Customer Terms
              contain a jury trial waiver provision and a mandatory arbitration provision. Please make sure
              you have the necessary authority to enter into the Agreement on behalf of Customer before
              proceeding. The Services are not intended for and should not be used by anyone under the age of
              18.
            </p>
          </div>

          <div className="flex flex-col gap-16 max-md:gap-12">
            {TERMS_SECTIONS.map((section) => (
              <div key={section.number} id={`section-${section.number}`} className="scroll-mt-[86px]">
                <h2 className="text-ink m-0 text-2xl leading-[1.2] font-bold tracking-[-0.01em]">
                  {section.number}. {section.title}
                </h2>
                <div className="text-md text-ink-700 [&_a]:text-brand-800 [&_a:hover]:text-ink mt-6 flex flex-col gap-6 leading-[1.6] [&_a]:underline [&_a]:underline-offset-2">
                  {section.body}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
